/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export interface PointDtoModel {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
}

export const distanceValidator = (point1: PointDtoModel, point2: PointDtoModel, threshold = 50): boolean => {
  const distance = calculateDistance(point1, point2);
  return distance <= threshold;
};

export const calculateDistance = (point1: PointDtoModel, point2: PointDtoModel): number => {
  const earthRadiusKm = 6371;

  function degreesToRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
  }

  const point1Lat = point1.latitude || 0;
  const point1Lon = point1.longitude || 0;
  const point2Lat = point2.latitude || 0;
  const point2Lon = point2.longitude || 0;

  const dLat = degreesToRadians(point2Lat - point1Lat);
  const dLon = degreesToRadians(point2Lon - point1Lon);

  const lat1 = degreesToRadians(point1Lat);
  const lat2 = degreesToRadians(point2Lat);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
};
